var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 3.6,
    fill: "#667085"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9999 9.00078C12.9999 9.25188 12.8111 9.45543 12.5782 9.45543H5.42179C5.1889 9.45543 5.0001 9.25188 5.0001 9.00078C5.0001 8.74969 5.1889 8.54613 5.42179 8.54613H12.5782C12.8111 8.54613 12.9999 8.74969 12.9999 9.00078Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4.68832C9.2329 4.68832 9.4217 4.89187 9.4217 5.14297L9.4217 12.8586C9.4217 13.1097 9.2329 13.3132 9 13.3132C8.7671 13.3132 8.5783 13.1097 8.5783 12.8586L8.5783 5.14297C8.5783 4.89187 8.7671 4.68832 9 4.68832Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsIcon);
export default __webpack_public_path__ + "static/media/actions_icon.0a9de08ca5f07e09bc1b9a7fc6ba4b0e.svg";
export { ForwardRef as ReactComponent };